import { render, staticRenderFns } from "./FormSubmissions.vue?vue&type=template&id=6e91532c&scoped=true"
import script from "./FormSubmissions.js?vue&type=script&lang=js&external"
export * from "./FormSubmissions.js?vue&type=script&lang=js&external"
import style0 from "./FormSubmissions.vue?vue&type=style&index=0&id=6e91532c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e91532c",
  null
  
)

export default component.exports